import { ApiPromise } from '@/types';
import { HTTP } from '@/utils';

export default class AttendanceTypeService {
  static resource = 'therapy-result-types';

  static getAttendanceTypes(): ApiPromise {
    return HTTP.get(this.resource);
  }
}
